export const CART_STORAGE_KEY = "lk_cart";
export const CART_VERSION = 2;

export const emptyCart = () => ({
  version: CART_VERSION,
  restaurant_id: null,
  restaurant_slug: null,
  restaurant_name: null,
  items: [],
});

export const readCart = (storage = window.localStorage) => {
  try {
    const raw = storage.getItem(CART_STORAGE_KEY);
    if (!raw) return { cart: emptyCart(), legacyInvalidated: false };
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return { cart: emptyCart(), legacyInvalidated: parsed.length > 0 };
    }
    const valid =
      parsed?.version === CART_VERSION &&
      Array.isArray(parsed.items) &&
      (parsed.items.length === 0 || (parsed.restaurant_id && parsed.restaurant_slug));
    return valid
      ? { cart: { ...emptyCart(), ...parsed }, legacyInvalidated: false }
      : { cart: emptyCart(), legacyInvalidated: Boolean(raw) };
  } catch {
    return { cart: emptyCart(), legacyInvalidated: true };
  }
};

export const cartOwner = (restaurant) => ({
  restaurant_id: restaurant.id,
  restaurant_slug: restaurant.slug,
  restaurant_name: restaurant.display_name,
});

